import React from "react";
import { useTranslation } from "@helpers/translate";
import { formatUsd } from "../../../../Controls/TradeForm/utils/format";
import "./TradeStats.sass";

/**
 * Wager, leverage and time held in three columns.
 *
 * @param {object} props
 * @param {number|null} props.wager
 * @param {number|null} props.leverage
 * @param {string|null} props.timeHeld
 */
export const TradeStats = ({ wager, leverage, timeHeld }) => {
  const { __ } = useTranslation();
  const stats = [
    [
      "wager",
      __("futures.community.wager"),
      wager != null ? formatUsd(wager) : "—",
    ],
    [
      "leverage",
      __("futures.leverage"),
      leverage != null ? `${leverage}x` : "—",
    ],
    ["time-held", __("futures.trade_details.time_held"), timeHeld ?? "—"],
  ];

  return (
    <dl className="trade-stats">
      {stats.map(([key, label, value]) => (
        <div key={key} className="trade-stats__item">
          <dt className="trade-stats__label">{label}</dt>
          <dd className={`trade-stats__value trade-stats__value--${key}`}>
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
};
